export default __webpack_public_path__ + "static/media/asc_order.f7bcc3ec.svg";